module.exports = __webpack_public_path__ + "static/media/MHRP21N0002.7a22f04e.svg";